import BarLoaderComponent from "./BarLoader";
import BeatLoaderComponent from "./BeatLoader";
import BounceLoaderComponent from "./BounceLoader";
import CircleLoaderComponent from "./CircleLoader";
import ClimbingBoxLoaderComponent from "./ClimbingBoxLoader";
import ClipLoaderComponent from "./ClipLoader";
import DotLoaderComponent from "./DotLoader";
import FadeLoaderComponent from "./FadeLoader";
import GridLoaderComponent from "./GridLoader";
import HashLoaderComponent from "./HashLoader";
import MoonLoaderComponent from "./MoonLoader";
import PacmanLoaderComponent from "./PacmanLoader";
import PropagateLoaderComponent from "./PropagateLoader";
import PulseLoaderComponent from "./PulseLoader";
import RingLoaderComponent from "./RingLoader";
import RiseLoaderComponent from "./RiseLoader";
import RotateLoaderComponent from "./RotateLoader";
import ScaleLoaderComponent from "./ScaleLoader";
import SkewLoaderComponent from "./SkewLoader";
import SquareLoaderComponent from "./SquareLoader";
import SyncLoaderComponent from "./SyncLoader";
export var BarLoader = BarLoaderComponent;
export var BeatLoader = BeatLoaderComponent;
export var BounceLoader = BounceLoaderComponent;
export var CircleLoader = CircleLoaderComponent;
export var ClimbingBoxLoader = ClimbingBoxLoaderComponent;
export var ClipLoader = ClipLoaderComponent;
export var DotLoader = DotLoaderComponent;
export var FadeLoader = FadeLoaderComponent;
export var GridLoader = GridLoaderComponent;
export var HashLoader = HashLoaderComponent;
export var MoonLoader = MoonLoaderComponent;
export var PacmanLoader = PacmanLoaderComponent;
export var PropagateLoader = PropagateLoaderComponent;
export var PulseLoader = PulseLoaderComponent;
export var RingLoader = RingLoaderComponent;
export var RiseLoader = RiseLoaderComponent;
export var RotateLoader = RotateLoaderComponent;
export var ScaleLoader = ScaleLoaderComponent;
export var SkewLoader = SkewLoaderComponent;
export var SquareLoader = SquareLoaderComponent;
export var SyncLoader = SyncLoaderComponent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-spinners/dist/index.js
// module id = 109
// module chunks = 0